import Damage from './Damage';

export default Damage;
export { Damage };
